import React from 'react'
import styled from 'styled-components/macro'

import SidebarLayout from '../templates/SidebarLayout'
import Header from '../components/organisms/Header'
import { Text } from '../components/atoms/Typography'
import LoggedOutFooter from '../components/organisms/Footer/LoggedOutFooter'
import SignupForm from '../components/organisms/Forms/SignupForm'

export default function Signup() {
  return (
    <SidebarLayout
      hideSidebar
      smallWrapper
      HeaderComp={
        <Header
          loggedOut
          title="Iscrizione"
          subtitle="Inserisci i tuoi dati per entrare nel mondo smart gym e iniziare ad allenarti."
        />
      }
      FooterComp={<LoggedOutFooter />}
    >
      <Article>
        <Text>
          <p>
            La registrazione a smart gym ti permette di acquistare entrate,
            scegliere la sede in cui vuoi allenarti e di prenotarla nei giorni
            in cui decidi tu.
            <br />
            <b>
              Ricordati di scaricare anche l'app mobile per poter entrare nella
              palestra.
            </b>
          </p>
        </Text>

        <SignupForm />
      </Article>
    </SidebarLayout>
  )
}

const Article = styled.article`
  max-width: 720px;

  form {
    margin-top: 24px;
  }
`
